import React from 'react';
import { useTranslation } from 'react-i18next';
import Card from '@mui/material/Card';
import CardActions from '@mui/material/CardActions';
import CardContent from '@mui/material/CardContent';
import Button from '@mui/material/Button';
import Typography from '@mui/material/Typography';
import CollapsibleTable from '../CollapsibleTable/CollapsibleTable';
import { ShiftSegmentTypeName } from '../../../Enums';
import { PartialIcon } from '../../components/core';
import { buildDailyShiftSegments } from '../../EmployeeDashboard/Utils/uiGenerators';
import _ from 'lodash';
import { getAsLongDate, getAsStartAndEndTimeFormat } from '../../../../common-client2/src/services/ukgDateTime';
import './ProposalCard.scss';

export default function ProposalCard(props) {
  const { t } = useTranslation('employmentBillboard');
  const hasActions = props.hasActions;
  let acceptedStatusId = [1, 2, 7];
  let acceptedProposal = props.proposals.find(x => acceptedStatusId.includes(x.status));
  let listToShow;

  if (acceptedProposal) {
    listToShow = [acceptedProposal];
  } else {
    listToShow = props.proposals;
  }
  return (
    <React.Fragment>
      {
        listToShow.map(ele =>
          <Card className="proposal-card">
            <CardContent >
              <Typography className="proposal-card-time" variant="h6" component="h2">
                {ele.name}
              </Typography>
              <Typography className="proposal-card-date" color="textSecondary">
                Proposed On: {ele.date} at {ele.time}
              </Typography>
              {ele.selectedAssignmentName && (
                <Typography className="proposal-card-date" color="textSecondary">
                  {t('billboard.assignment', { name: ele.selectedAssignmentName })}
                </Typography>
              )}
              <CollapsibleTable
                data={_.sortBy(ele.shifts, ['startDateTime'])}
                columns={[
                  {
                    title: 'Date',
                    field: 'startDateTime',
                    render: (row) => getAsLongDate(ele.isPartial ? ele.partialShift.startDateTime : row.startDateTime),
                  },
                  {
                    title: 'Shift',
                    field: 'label',
                    render: (row) => {
                      const isPartialShift = ele.isPartial;
                      const startDate = isPartialShift ? ele.partialShift.startDateTime : row.startDateTime;
                      const endDate = isPartialShift ? ele.partialShift.endDateTime : row.endDateTime;
                      const transferExists = row.segments.find(segment => segment.type === ShiftSegmentTypeName.TRANSFER_SEGMENT) ? '(x)' : '';
                      const shiftLabel = `${row.label ?? ""} ${getAsStartAndEndTimeFormat(startDate, endDate)} ${transferExists}`;
                      if (isPartialShift) {
                        return (
                          <React.Fragment>
                            <PartialIcon />
                            <span style={{ padding: '0 5px' }}>
                              {shiftLabel}
                            </span>
                          </React.Fragment>
                        )
                      }
                      return (
                        <React.Fragment>
                          {shiftLabel}
                        </React.Fragment>
                      )
                    },
                  },
                ]}
                renderDetails={(row) => {
                  const shift = ele.isPartial ? ele.partialShift : row;
                  return (
                    <div>
                      <Typography variant="h6" gutterBottom component="div">
                        Segments
                      </Typography>
                      {buildDailyShiftSegments(shift)}
                    </div>
                  );
                }}
                defaultOpen={true}
              />
            </CardContent>
            {
              hasActions &&
              <CardActions>
                <Button onClick={() => props.handleAcceptButton(ele.proposalId)} className="proposal-card-button proposal-card-accept-button" size="medium">Accept</Button>
                <Button onClick={() => props.handleRejectButton(ele.proposalId)} className="proposal-card-button proposal-card-reject-button" size="medium">Decline</Button>
              </CardActions>
            }
          </Card>
        )
      }
    </React.Fragment>
  );
}